import { render } from "./DashobardPaymentMethodPage.vue?vue&type=template&id=49371e14"
import script from "./DashobardPaymentMethodPage.vue?vue&type=script&lang=js"
export * from "./DashobardPaymentMethodPage.vue?vue&type=script&lang=js"

import "./DashobardPaymentMethodPage.vue?vue&type=style&index=0&id=49371e14&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__